import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { RfpProfessionalFileSkeleton } from '@/components/modules/pages/rfp/professional/Content/RfpProfessionalFileContent';
import { RfpProfessionalFileContent } from '@/components/modules/pages/rfp/professional/Content/RfpProfessionalFileContent/RfpProfessionalFileContent';
import { RfpProfessionalOneApprovedContainer } from '@/components/modules/pages/rfp/professional/Layout/RfpProfessionalOneApprovedContainer/RfpProfessionalOneApprovedContainer';
import { rfpProOneTabValueFile } from '@/components/modules/pages/rfp/professional/tab/RfpProOneTab';
import { isNotEmptyNumber } from '@/utils/checkValue/number';
import { getIsOfferDisabled } from '@/utils/modules/rfp/professional/isOfferDisabled';
import { myPagePath, professionalRfpListPath } from '@/utils/router/links';
/** パンくずリスト */
const baseBreadcrumbs = [
    {
        link: myPagePath(),
        text: 'マイページ',
    },
    {
        link: professionalRfpListPath(),
        text: '募集中のプロジェクト',
    },
];
/**
 * コンサルタント：案件詳細（ファイル共有）のコンテンツ部分を表示するコンポーネント
 * @constructor
 */
export const ProfessionalRfpFileView = (props) => {
    const { displayLastMessage, fileShare, isAdminUser, isUploading, onClickDraft, onClickFileLink, onClickSubmit, onInspectFileStatus, professionalId, rfp, uploadFile, user, } = props;
    // メッセージのデータをコンポーネントに渡すための変換処理
    const chatItems = useMemo(() => ((fileShare === null || fileShare === void 0 ? void 0 : fileShare.messages) || []).map((message) => {
        const clientId = message.client_id;
        const isClientMessage = message.is_client;
        return {
            message: {
                files: message.files.map((file) => ({
                    // リンククリック時にはこのIDを使ってアクセスする
                    id: file.rfp_share_document_message_file_id,
                    name: file.name,
                })),
                isBox: !message.is_same_organization && !message.is_self,
                message: message.message || '',
                messageId: message.id,
                time: message.published_at,
                unread: message.is_unread,
            },
            user: {
                clientId: isClientMessage && isNotEmptyNumber(clientId)
                    ? clientId.toString()
                    : '',
                firstName: isClientMessage ? '' : message.first_name,
                imageSrc: message.image_src,
                isRetired: message.is_retired,
                isShowDetailPage: message.has_professional_detail_page,
                lastName: isClientMessage
                    ? 'クライアント企業担当者より'
                    : message.last_name,
                professionalId: isNotEmptyNumber(message.professional_id)
                    ? message.professional_id.toString()
                    : '',
                professionalType: message.professional_type,
            },
        };
    }), [fileShare]);
    /** メッセージ送信可能か */
    const isShowForm = useMemo(() => {
        const isOfferDisabled = getIsOfferDisabled({
            hasOffer: rfp.has_offer,
            ignoreCallEndDate: rfp.is_calling,
            isCalling: rfp.ignore_call_end_date,
        });
        return (
        // 提案期限が過ぎていないか
        !isOfferDisabled &&
            // 管理者ユーザーではないか
            !isAdminUser &&
            // やり取りが可能（閲覧申請した）ユーザーか
            rfp.view_request_user.id === professionalId);
    }, [rfp, isAdminUser, professionalId]);
    return (_jsx(RfpProfessionalOneApprovedContainer, Object.assign({ activeTab: rfpProOneTabValueFile, breadcrumbs: [...baseBreadcrumbs, { text: rfp.name }], isAdminUser: isAdminUser, professionalId: professionalId, rfp: rfp }, { children: _jsx("div", Object.assign({ className: 'py-32 px-16 md:px-28' }, { children: fileShare ? (_jsx(RfpProfessionalFileContent, { displayLastMessage: displayLastMessage, draftMessage: fileShare.draft_message, isShowForm: isShowForm, isUploading: isUploading, items: chatItems, onClickDraft: onClickDraft, onClickFileLink: onClickFileLink, onClickSubmit: onClickSubmit, onInspectFileStatus: onInspectFileStatus, status: fileShare.status, uploadFile: uploadFile, user: user, viewRequestUserName: `${rfp.view_request_user.last_name} ${rfp.view_request_user.first_name}` })) : (_jsx(RfpProfessionalFileSkeleton, {})) })) })));
};
